import { ImageSource, ScreenElement, Sprite, Timer, vec } from "excalibur";
import { Resources } from "../../resources";
import { LevelOne } from "../../scenes/level-one/level-one";
import { random_int } from "../../util";

const padding = 8;

export class Die extends ScreenElement {
    public rolling = true;
    public face: number;

    constructor(private level: LevelOne, x: number, y: number, size: number) {
        super({
            pos: vec(x + padding, y + padding),
            width: size - padding * 2,
            height: size - padding * 2,
        });
    }

    onInitialize() {
        this.setFace(random_int(1, 6));

        const timer = new Timer({ interval: 50, repeats: true });

        timer.on(() => this.rollUpdate());

        this.level.add(timer);

        timer.start();
    }

    rollUpdate() {
        if (this.rolling) {
            this.setFace(random_int(1, 6));
        }
    }

    stop() {
        this.rolling = false;
    }

    private setFace(face: number) {
        this.face = face;
        
        let image: ImageSource;

        switch (face) {
            case 1:
                image = Resources.die1;
                break;
            case 2:
                image = Resources.die2;
                break;
            case 3:
                image = Resources.die3;
                break;
            case 4:
                image = Resources.die4;
                break;
            case 5:
                image = Resources.die5;
                break;
            case 6:
                image = Resources.die6;
                break;
        }

        this.graphics.use(
            new Sprite({
                image,
                destSize: {
                    width: this.width,
                    height: this.height,
                }
            })
        );
    }
}